import React, { useEffect, useState } from 'react';
import CrystalService from 'business/services/CrystalService';
import { CrystalDTO } from 'business/models/Models';
import CrystalDetails from 'components/crystal/crystalDetails';
import CrystalModal from './crystalModal';
import { CrystalModalDetails } from './types';

const crystalService = new CrystalService();

const Crystal = () => {
  const [crystalModalDetails, setCrystalModalDetails] = useState<CrystalModalDetails>({
    showModal: false,
    body: null,
  });

  const [unassignedCrystals, setUnassignedCrystals] = useState<CrystalDTO[]>();

  useEffect(() => {
    const fetchUnassignedCrystals = async () => {
      return await crystalService.getAllUnassignedCrystals();
    };
    fetchUnassignedCrystals().then((data) => {
      setUnassignedCrystals(data);
    });
  }, []);

  const openCrystal = (crystalId: number) => {
    setCrystalModalDetails(() => ({
      ...crystalModalDetails,
      showModal: true,
      body: <CrystalDetails crystalId={crystalId} editMode />,
    }));
  };

  const closeCrystalModal = () => {
    setCrystalModalDetails({
      ...crystalModalDetails,
      showModal: false,
      body: null,
    });
  };

  return (
    <>
      {unassignedCrystals?.map((c) => (
        <a
          id={`crsytal-index-${c.name}`}
          className="tw-inline cursor-pointer rounded-full bg-blue-500 text-white ml-1 p-1"
          onClick={() => openCrystal(c.id)}
          key={c.id}
        >
          {c.name}
        </a>
      ))}
      <CrystalModal {...crystalModalDetails} closeModal={closeCrystalModal} />
    </>
  );
};

export default Crystal;
